
import React, { useEffect } from 'react';
import './Trampoline.css';
import trampoline from "../../../assets/img/imagefile/imagefile/trampolinepark2.png"
import AOS from 'aos';
import 'aos/dist/aos.css';
import playground from '../../../assets/gem_products/Performance.jpg';
import trampoline1 from '../../../assets/gem_products/Trampoline.jpg';
import interactiveGame from '../../../assets/gem_products/basket.jpg';
import formpit from '../../../assets/gem_products/balance.jpg';
import dodgeball from '../../../assets/gem_products/dodge ball.jpg';
import wipeout from '../../../assets/gem_products/wipeout.jpg';
import airbag from '../../../assets/gem_products/airbag.jpg';
import plusicon from '../../../assets/img/product_img/plusicon.png';
import { Link } from "react-router-dom";
import Dashboard from '../../../components/Dashboard';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import Breadcrumb from '../../../Breadcrumb';
import { Helmet } from "react-helmet-async";
import WhatsappButton from '../../../components/WhatsappButton';
// import Cardlist from '../components/Cardlist';

const Tramp = () => {
  useEffect(() => {
    AOS.init();
  }, [])
  let description = (<><h2 className='dashboard-content'>As a leading Trampoline Park Manufacturer in Jordan, We Global Entertainment Manufacturer designs high-quality performance trampolines for trampoline parks. Built with premium materials, our trampolines deliver greater height, improved airtime, and ultimate control.</h2></>)
  return (
    <div>
      <Helmet>
                <meta name="trampoline parks" content="Experience ultimate fun at GEM Trampoline Parks! 
Jump, flip & soar in a safe, thrilling environment perfect
 for all ages. Visit GEM for the best trampoline 
adventure!" />
              </Helmet>


      <Header />
      <Dashboard
        Breadcrumb={
          <div style={{ backgroundColor: '', marginTop: '13%', marginLeft: '3%', borderRadius: '5px' }}>
            <Breadcrumb />
          </div>
        }
        title="Trampoline Park"
        imageUrl={trampoline}
        description={description}
      />
      <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />

      {/* <Cardlist /> */}

      <section className="product-section">
        <div >
          <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="icon-container">
              <img
                src={plusicon}
                alt="playground equipment suppliers"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>
        </div>

        <div className="product-container">
          <div className='product-row'>
            <div className="product" >
              <Link to="/TrampolinePark/Trampoline" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={trampoline1} alt="indoor commercial playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>
                  Trampoline
                </p>
              </Link>
            </div>
            <div className="product">
              <Link to="/TrampolinePark/Performance" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={playground} alt="playground equipment manufacturers" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Performance Trampoline</p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/TrampolinePark/BasketballTrampoline" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={interactiveGame} alt="trampoline park with soft play" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Basketball Trampoline
                </p>
              </Link>
            </div>
          </div>
          <div className='product-row'>
            <div className="product" >
              <Link to="/TrampolinePark/FoamPit-BalanceZone" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={formpit} alt="playgrounds" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Foam Pit / Balance Zone
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/TrampolinePark/DodgeBall" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={dodgeball} alt="soft play" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Dodge Ball
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/TrampolinePark/WipeOut" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={wipeout} alt="trampoline company" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Wipe Out</p>
              </Link>
            </div>

          </div>

          <div className='product-row'>
            <div className="product" >
              <Link to="/TrampolinePark/AirBag" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={airbag} alt="trampoline parks" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Air Bag
                </p>
              </Link>
            </div>

          </div>
        </div>

      </section>
      {/* Include Footer component */}
      <Footer />
    </div>
  );
};




export default Tramp;
